import gql from 'graphql-tag';

const END_TRACKING = gql`
  mutation endTracking($trackingId: Int!) {
    userFlowStepTrack {
      endUserFlowStep(trackingId: $trackingId, status: COMPLETED) {
        id
      }
    }
  }
`;

const PAGE_HAS_BEEN_VIEWED = gql`
  query hasBeenViewed($pageId: Int!) {
    contentPage {
      hasBeenViewed(pageId: $pageId)
    }
  }
`;

const START_TRACKING = gql`
  mutation trackUserFlowStep($userFlowStepId: Int!) {
    userFlowStepTrack {
      startUserFlowStep(stepId: $userFlowStepId) {
        id
      }
    }
  }
`;

export { END_TRACKING, PAGE_HAS_BEEN_VIEWED, START_TRACKING };
